import { createContext } from 'react'

const FirstStepContext = createContext()

export default FirstStepContext
